/*
 * Intl (Constants)
 */
export const localePrefix: any = "always"

export const LocaleEnum = {
	enUS: "en-US",
	frCA: "fr-CA",
} as const
export type LocaleEnum = (typeof LocaleEnum)[keyof typeof LocaleEnum]

export const defaultLocale: LocaleEnum = LocaleEnum.enUS
export const supportedLocales: LocaleEnum[] = [LocaleEnum.enUS, LocaleEnum.frCA]
